import {
  ClientConfirmPhoneNumberDocument,
  type ClientConfirmPhoneNumberMutation,
  type ClientConfirmPhoneNumberMutationVariables,
} from "@/__generated__/graphql";
import { createRequestFactory } from "@/lib/request-factory";
import { storage } from "@/lib/storage";

type Response = {
  success: boolean;
};

export const useClientConfirmPhoneNumberStore = createRequestFactory<
  ClientConfirmPhoneNumberMutation,
  Response,
  ClientConfirmPhoneNumberMutationVariables
>({
  method: "mutation",
  graphqlDocument: ClientConfirmPhoneNumberDocument,
  transformFunction: (res) => {
    return { success: !!res.clientConfirmPhoneNumber?.result };
  },
  onFetchSuccess({ success }) {
    if (success) {
      storage.setItem("ONBOARDING", "true").catch((e) => {
        console.log("unable to set ONBOARDING. Error:", e);
      });
    }
  },
});
